// action types

export const FETCH_DATA_LOADING = "TRACK_FETCH_DATA_LOADING";
export const FETCH_DATA_FAILURE = "TRACK_FETCH_DATA_FAILURE";
export const FETCH_DATA_SUCCESS = "TRACK_FETCH_DATA_SUCCESS";
export const FETCH_AUDIO_DATA_SUCCESS = "TRACK_FETCH_AUDIO_DATA_SUCCESS";

export const SET_FORM_VISIBLE = "SET_FORM_VISIBLE";
